import { createSlice } from "@reduxjs/toolkit";
import { drmtFilterPayload } from "../../constData/filterRequestPayloadDrmt";

const drmTableFilterSlice = createSlice({
  name: "drmTableFilter",
  initialState: {
    tableFilter: drmtFilterPayload,
  },
  reducers: {
    setDrmTableFilter: (state, action) => {
      state.tableFilter = { ...state.tableFilter, ...action.payload };
    },
    resetDrmTableFilter: (state) => {
      state.tableFilter = {
        ...drmtFilterPayload,
        division: state.tableFilter.division,
        originCountry: state.tableFilter.originCountry,
        destinationCountry: state.tableFilter.destinationCountry,
      };
    },
  },
});

export const { setDrmTableFilter, resetDrmTableFilter } =
  drmTableFilterSlice.actions;
export default drmTableFilterSlice.reducer;
